import { fetchBaseQuery, retry } from '@reduxjs/toolkit/query/react'
import axiosIns from 'app/axiosInstance'
import config from 'app/config'

export const baseQuery = fetchBaseQuery({
    baseUrl: config.API_BASE_URL,
    credentials: 'include',
})

export const staggeredBaseQuery = retry(baseQuery, { maxRetries: config.MAXIMUM_API_RETRIES })

export const staggeredBaseQueryWithBailOut = retry(
    async (args, api, extraOptions) => {
        const result = await baseQuery(args, api, extraOptions)
        // bail out of re-tries immediately if unauthorized,
        if (result.error?.status === 401) {
            retry.fail(result.error)
        }
    },
    {
        maxRetries: config.MAXIMUM_API_RETRIES,
    }
)

export const axiosBaseQuery =
    ({ baseUrl } = { baseUrl: config.API_BASE_URL }) =>
    async args => {
        const url = typeof args === 'object' ? args.url : args
        const method = typeof args === 'object' ? args.method : 'GET'
        const data = typeof args === 'object' ? args.body : null

        try {
            if (!navigator.onLine) {
                return { error: { message: `Couldn't connect to the internet!` } }
            }

            const result = await axiosIns().request({
                url,
                method,
                data,
            })

            return { data: result.data }
        } catch (error) {
            throw error
        }
    }
